import { MembershipsBadgesApiClient } from '@fourthwall/services/dist/MembershipsBadgesApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useEditVerifiedBadgeMutation = createMutationHook(
  MembershipsBadgesApiClient.editVerifiedBadge,
  {
    mutationKey: ['editVerifiedBadge'],
  },
)
